import React, { useState, useEffect } from "react";
import {
  MdDashboard,
  MdPeople,
  MdAccountBox,
  MdOutlineBusinessCenter,
  MdOutlineLibraryAdd,
  MdOutlineViewList,
} from "react-icons/md";
import { BiLogOutCircle } from "react-icons/bi";
import { Link } from "react-router-dom";
import "./style.min.css";
import SidebarMenu from "./SidebarMenu";
const Sidenavbar = () => {
  const [windowDimension, setWindowDimension] = useState(window.innerWidth);
  const [isOpen, setIsOpen] = useState(true);
  const detectSize = () => {
    setWindowDimension(window.innerWidth);
    if (windowDimension < 768) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };
  useEffect(() => {
    if (windowDimension < 768) {
      setIsOpen(false);
    }
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimension]);

  const [item, setItem] = useState([
    // {
    //   title: "Lssf Mgmt",
    //   icon: <MdPeople className="my__nav__icon" />,
    //   dropDown: [
    //     {
    //       title: "Sewing Applications",
    //       icon: <MdAccountBox className="my__nav__icon" />,
    //       href: "/dashboard/lssf/sewing-applications",
    //     },
    //     {
    //       title: "Health Camp Applications",
    //       icon: <MdOutlineLibraryAdd className="my__nav__icon" />,
    //       href: "/dashboard/lssf/health-applications",
    //     },
    //     {
    //       title: "Tricycle Applications",
    //       icon: <MdOutlineViewList className="my__nav__icon" />,
    //       href: "/dashboard/lssf/tricycle-applications",
    //     },
    //     {
    //       title: "Cataract Applications",
    //       icon: <MdOutlineViewList className="my__nav__icon" />,
    //       href: "/dashboard/lssf/cataract-applications",
    //     },
    //     {
    //       title: "Farmer Applications",
    //       icon: <MdOutlineViewList className="my__nav__icon" />,
    //       href: "/dashboard/lssf/farmer-applications",
    //     },
    //     {
    //       title: "Running Competition",
    //       icon: <MdOutlineViewList className="my__nav__icon" />,
    //       href: "/dashboard/lssf/running-competition",
    //     },
    //     {
    //       title: "Contact Enquiries",
    //       icon: <MdOutlineViewList className="my__nav__icon" />,
    //       href: "/dashboard/lssf/contact-enquiries",
    //     },
    //     {
    //       title: "Donations",
    //       icon: <MdOutlineViewList className="my__nav__icon" />,
    //       href: "/dashboard/lssf/donations",
    //     },
    //   ],
    // },
      {
      title: "Mbbs Duniya Mgmt",
      icon: <MdPeople className="my__nav__icon" />,
      dropDown: [
        {
          title: "Counseling Details",
          icon: <MdAccountBox className="my__nav__icon" />,
          href: "/dashboard/mbbs/counseling-details",
        },
        {
          title: "Contact Enquiry",
          icon: <MdOutlineLibraryAdd className="my__nav__icon" />,
          href: "/dashboard/mbbs/contact-enquiry",
        },
        {
          title: "Students List",
          icon: <MdOutlineViewList className="my__nav__icon" />,
          href: "/dashboard/mbbs/students-list",
        },
        {
          title: "Add College",
          icon: <MdOutlineViewList className="my__nav__icon" />,
          href: "/dashboard/mbbs/add-college",
        },
                {
          title: "College List",
          icon: <MdOutlineViewList className="my__nav__icon" />,
          href: "/dashboard/mbbs/college-list",
        },
        {
          title: "Blog List",
          icon: <MdOutlineViewList className="my__nav__icon" />,
          href: "/dashboard/mbbs/blogs",
        }
      ],
    },
  ]);
  return (
    <aside className="left-sidebar" data-sidebarbg="skin5">
      {/* <!-- Sidebar scroll--> */}
      <div className="scroll-sidebar">
        {/* <!-- Sidebar navigation--> */}
        <nav className="sidebar-nav">
          <ul id="sidebarnav" className="pt-4">
            <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="dash_board"
                aria-expanded="false"
              >
                <MdDashboard
                  size={23}
                  style={{
                    display: "inline-block",
                    color: "white",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">Dashboard</span>
              </Link>
            </li>
            {item.map((item, index) => {
              return (
                <SidebarMenu
                  title={item.title}
                  icon={item.icon}
                  dropDown={item.dropDown}
                  key={index}
                />
              );
            })}
            {/* <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/certificates"
                aria-expanded="false"
              >
                <MdDashboard
                  size={23}
                  style={{
                    display: "inline-block",
                    color: "white",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">Certificates</span>
              </Link>
            </li>
  <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/media"
                aria-expanded="false"
              >
                <MdDashboard
                  size={23}
                  style={{
                    display: "inline-block",
                    color: "white",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">Media</span>
              </Link>
            </li>
              <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/gallery"
                aria-expanded="false"
              >
                <MdDashboard
                  size={23}
                  style={{
                    display: "inline-block",
                    color: "white",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">Gallery</span>
              </Link>
            </li>

                <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/events"
                aria-expanded="false"
              >
                <MdDashboard
                  size={23}
                  style={{
                    display: "inline-block",
                    color: "white",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">Events Gallery</span>
              </Link>
            </li> */}
            <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/logout"
                aria-expanded="false"
              >
                <BiLogOutCircle
                  size={23}
                  style={{
                    display: "inline-block",
                    color: "white",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">Logout</span>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Sidenavbar;
